import cxs from 'classnames/bind'
import LabelPosition from 'types/LabelPosition'
import React, { useState, useRef, useEffect } from 'react'
import { Input } from 'components'
import { IProps } from './Interface'
import { useOutsideClick } from 'utils'
import { FormLabel, Grid, GridDirection, GridItemsAlignment } from '@material-ui/core'
import useStyles from './Styles'

const FreeText: React.FC<IProps> = ({
  hideLabel,
  onSave,
  id,
  showLimit,
  limit,
  textColor,
  label,
  textSize,
  displayHover,
  initialValue,
  inputProps,
  alwaysEnabled,
  labelPosition,
  classNames,
  onChange,
  ...props
}) => {
  const classes = useStyles({ labelPosition, textSize, textColor })
  const [disabled, setDisabled] = useState<boolean>(!alwaysEnabled)
  const [value, setValue] = useState(initialValue)
  const ref = useRef()
  const { error } = props

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleClick = () => {
    if (disabled && displayHover && !alwaysEnabled) {
      setDisabled(false)
    }
  }

  useOutsideClick(ref, () => {
    if (!error && displayHover && !alwaysEnabled && !disabled) {
      setDisabled(true)
      onSave(value)
    }
  })

  // tslint:disable-next-line: no-shadowed-variable
  const handleChange = (value: string) => {
    setValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  const displayLabelPosition = () => {
    switch (labelPosition) {
      case LabelPosition.Top:
        return {
          direction: 'column',
          alignItems: 'flex-start'
        }
      case LabelPosition.Left:
        return {
          direction: 'row',
          alignItems: 'center'
        }
    }
  }

  const cx = cxs.bind(classes)
  const labelClasses = cx({
    label: true,
    labelTop: labelPosition === LabelPosition.Top
  })

  return (
    <Grid
      container
      direction={displayLabelPosition().direction as GridDirection}
      alignItems={displayLabelPosition().alignItems as GridItemsAlignment}
      className={classNames.root}
    >
      {(!hideLabel || !(disabled || props.disabled)) && label && (
        <Grid item className={classNames.labelContainer}>
          <FormLabel id={`${id}-label`} className={labelClasses}>
            {label}
          </FormLabel>
        </Grid>
      )}
      <Grid item onClick={handleClick} ref={ref} className={classNames.inputContainer}>
        <Input
          id={id}
          disabled={disabled as boolean}
          showLimit={showLimit}
          limit={limit}
          onChanged={handleChange}
          textColor={textColor}
          textSize={textSize}
          displayHover={displayHover}
          initialValue={initialValue}
          inputProps={inputProps}
          {...props}
        />
      </Grid>
    </Grid>
  )
}

FreeText.defaultProps = {
  limit: 24,
  showLimit: false,
  textSize: 12,
  textColor: '#000',
  initialValue: '',
  rows: 3,
  displayHover: true,
  hideLabel: false,
  labelPosition: LabelPosition.Left,
  alwaysEnabled: false,
  classNames: {
    root: '',
    inputContainer: ''
  },
  onSave: value => value,
  onChange: value => value
}

export default FreeText
